/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./batch-upload.vue?vue&type=template&id=21a9a0ae&scoped=true&"
import script from "./batch-upload.vue?vue&type=script&lang=ts&"
export * from "./batch-upload.vue?vue&type=script&lang=ts&"
import style0 from "./batch-upload.vue?vue&type=style&index=0&id=21a9a0ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a9a0ae",
  null
  
)

export default component.exports